export const availableWorkflows = {
  ONBOARDING: 'onboarding',
};
